import { axiosCashJournalClient } from "../api";
import { MIDDLE_URL } from "../config";
import { IGetTrxTypeResponse } from "./types";

export const url = "/v1/smplmsttrxtype";

export const getTrxType = async (): Promise<IGetTrxTypeResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
  });

  return data;
};
